/**
 * /admins/invite — thin route shim.
 *
 * Loader prefetches the RBAC catalog so the page's role dropdown
 * is populated on first paint rather than flashing a spinner.
 * The catalog is immutable per deploy so `staleTime: Infinity`
 * in the hook ensures one fetch per session.
 */

import { createFileRoute } from "@tanstack/react-router";
import { InviteAdminPage } from "@/features/platform-admins/pages/invite-admin-page";
import { fetchRBACCatalog } from "@/features/platform-admins/rbac-queries";
import { queryKeys } from "@/lib/query-keys";

export const Route = createFileRoute("/_authed/admins/invite")({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData({
      queryKey: queryKeys.rbacCatalog,
      queryFn: fetchRBACCatalog,
      staleTime: Infinity,
    }),
  component: InviteAdminPage,
});
